module.exports = __webpack_public_path__ + "static/media/undraw_cookie_love_ulvn.89a26189.svg";